import React, { Component } from "react";
import { ValuationCompany } from "../../valuationapi/entities";
import { LocaleUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";

interface Props {
	company: ValuationCompany,
	onDownloadCertificate: () => void,
	onViewRankingDetails: () => void
}

interface State {
	company: ValuationCompany;
}

class ValuationCompanyDetails extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
	}

	componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ): void {
		this.setState( { company: nextProps.company } );
	}

	render() {
		return <>
			<div className="broker-dev-project">
				<div className="card mb-3 bg-light">
					<div className="card-body dev-project-body">
						<div className="dev-project-img-holder">
							<div className="box-img"><img
								id="imgOfficeLogo"
								src={ this.props.company.logoUrl }
								className="img-fluid" alt="Office Logo"/></div>
						</div>
						<div className="dev-project-holder">
							<div className="custom-card-title">
								<div id="brokerofficename">{ LocaleUtil.getLocalValue( this.props.company.name ) }
								</div>
							</div>
							<ul className="list-style font-size14">
								<li>{ Strings.license_no } <span
									id="officeNumber">{ this.props.company.licenseNumber }</span></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="flex-grid">
				<div>
					<span className="d-flex align-items-center">{ Strings.ranking_details }</span>
					<span className="d-flex align-items-center justify-content-between">
                        <span className="medal medal-ranking d-flex align-items-center">
                            <span className={ getClassificationRank( this.props.company.rank as number ) }/>
                            <strong>{ Strings.total_points_ev + this.props.company.classificationValue }</strong>
                        </span>
                        <button
	                        onClick={ this.props.onViewRankingDetails } type="button"
                            className="btn btn-link font-size14 doc-blue-link" data-bs-toggle="modal"
	                        data-bs-target="#rankingDetailsModal">{ Strings.view_ranking_details }</button>
                    </span>
				</div>
				<div>
					<span>{ Strings.download_certificate }</span>
					<button
						onClick={ this.props.onDownloadCertificate } type="button"
                        className="btn btn-link font-size14 doc-blue-link" data-bs-toggle="modal"
						data-bs-target="#rankingDetailsModal">{ Strings.download }</button>
				</div>
				<div>
					<span>{ Strings.email }</span>
					<span>{ this.props.company.email }</span>
				</div>
				<div>
					<span>{ Strings.phone }</span>
					<span>{ this.props.company.phone }</span>
				</div>
			</div>
		</>;
	}
}

export function getClassificationRank( rank: number ) {
	switch ( rank ) {
		case 1:
			return "general me-2";
		case 2:
			return "bronze me-2";
		case 3:
			return "silver me-2";
		case 4:
			return "gold me-2";
		case 11:
			return "general me-2";
		case 12:
			return "bronze me-2";
		case 13:
			return "silver me-2";
		case 14:
			return "gold me-2";
		default:
			return "general me-2";
	}
}

export default ValuationCompanyDetails;
